import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ReactComponent as Close } from 'src/assets/images/close.svg';
import styles from './styles.module.css';
import { trackEvent, CLICKED_UPGRADE_BANNER, NURTURE_BAR_TYPES } from '../../../util/segment';
import {
  isActiveAccountState,
  isTrialAccountState,
  isUserAnOwnerOrAdmin,
} from '../../../redux/fe-data/selectors';

const upgrade = async () => {
  await trackEvent(CLICKED_UPGRADE_BANNER, {
    notificationType: '',
    nurtureBarType: NURTURE_BAR_TYPES.accountOwner,
  });
  window.location.href = '/account/settings/subscription/purchase/plans';
};

const getUpgradeCTA = (daysLeft) => {
  if (daysLeft) {
    return `There are ${daysLeft} days left on your free trial`;
  }
  return 'Your PagerDuty trial has expired.';
};

function NurtureBarSummary(props) {
  const { daysLeft, userCanViewCheckout, showConfirmExitModal } = props;

  const getSummaryContent = () => {
    const goalsLeft = props.totalSteps - props.totalCompletedSteps;
    const pluralize = goalsLeft > 1 ? 's' : '';
    const completedNone = goalsLeft === props.totalSteps;
    const viewGoalsCta = completedNone ? 'Get Started' : `See Goal${pluralize}`;
    if (goalsLeft === 0) {
      return {
        text: 'You\'ve completed all onboarding goals!',
        viewGoalsCta: 'See Goals Again',
      };
    }
    return {
      text: `You have ${goalsLeft} onboarding goal${pluralize} ${completedNone ? '' : 'left '}to finish`,
      viewGoalsCta,
    };
  };

  const getDaysLeftNotification = () => (
    <div className={styles.nurtureBarCol2}>
      <div className={styles.upgrade} data-test="days-left-notification">
        {getUpgradeCTA(daysLeft)}
        {
          userCanViewCheckout && (
            <button className={styles.btnUpgradeNow} type="button" onClick={() => upgrade()} data-test="upgrade-now-button">
              Upgrade Now
            </button>
          )
        }
      </div>
    </div>
  );

  const getExitNurtureBarButton = () => (
    <div className={styles.right}>
      <span role="button" tabIndex="0" onKeyPress={showConfirmExitModal} onClick={showConfirmExitModal} data-test="exit-nurture-button">
        <Close />
      </span>
    </div>
  );

  const summaryContent = getSummaryContent();

  return (
    <div className={styles.nurtureBarSummary} data-test="trial-nurture-bar-summary">
      <div
        className={styles.nurtureBarCol1}
        role="button"
        tabIndex="0"
        onClick={() => props.onSummaryClick(summaryContent.text)}
        onKeyPress={() => props.onSummaryClick(summaryContent.text)}
        data-test="goals-summary"
      >
        <div className={styles.text}>
          {summaryContent.text}
        </div>
        <div className={styles.btnViewGoals}>{summaryContent.viewGoalsCta}</div>
      </div>
      {props.isTrialAccount && getDaysLeftNotification()}
      {props.isActiveAccount && getExitNurtureBarButton()}
    </div>
  );
}

NurtureBarSummary.defaultProps = {
  daysLeft: null,
  showConfirmExitModal: () => null,
};

NurtureBarSummary.propTypes = {
  onSummaryClick: PropTypes.func.isRequired,
  totalCompletedSteps: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  daysLeft: PropTypes.number,
  showConfirmExitModal: PropTypes.func,
  isTrialAccount: PropTypes.bool.isRequired,
  isActiveAccount: PropTypes.bool.isRequired,
  userCanViewCheckout: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isActiveAccount: isActiveAccountState(state),
  isTrialAccount: isTrialAccountState(state),
  userCanViewCheckout: isUserAnOwnerOrAdmin(state),
});

export default connect(mapStateToProps)(NurtureBarSummary);
